<template>
    <form @submit.prevent="onSubmit">
        <div class="modal-main">
            <h3>Send SMS</h3>
            <div class="checkbox" v-if="!pagesWithPrimaryOrSecondaryParentOption.includes(this.$route.path)">
                <p class="checkbox__select-label">Select who will receive message</p>
                <div class="checkbox__input">
                    <div class="checkbox-item__container">
                        <input 
                            type="checkbox" 
                            id="primary" 
                            value="primary" 
                            v-model="entitySelected">
                        <label 
                            for="primary">
                            Primary Contact
                        </label>
                    </div>
                    <div class="checkbox-item__container">
                        <input 
                            type="checkbox" 
                            id="secondary" 
                            value="secondary" 
                            v-model="entitySelected">
                        <label 
                            for="secondary">
                            Secondary Contact
                        </label>
                    </div>
                </div>
            </div>
            <textarea name="sms"
                      id="sms"
                      placeholder="Please enter text message"
                      v-validate="'required|max:200'"
                      v-model="form.message">
            </textarea>
            <div class="error position-relative">{{ errors.first('sms') }}</div>
            <p class="message-note">Note: Messages are sent one way and parents are not able to reply.</p>
        </div>
        <div class="form-footer">
            <button class="primary-btn btn-center"
                    type="submit"
                    :disabled="!formValid || formPristine"
                    v-spinner="isLoading">
                Send
            </button>
        </div>
    </form>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FormMixin } from '@/mixins/FormMixin';
    import SpinnerDirective from '@/directives/SpinnerDirective';
    export default {
        name: 'SendSMSModal',
        components: {
            TextEditor: () => import('@/components/controls/TextEditor')
        },
        directives: { SpinnerDirective },
        mixins: [FormMixin],
        data() {
            return {
                form: {
                    message: null,
                    secondaryEntityIds: [],
                    entityIds: [],
                },
                isLoading: false,
                pagesWithPrimaryOrSecondaryParentOption: ["/settings/users", "/settings/sms_history"],
                entitySelected: ['primary'],
            }
        },
        computed: {
            ...mapGetters([
                'selected',
                'schoolId',
                'options',
                'resendSMS'
            ])
        },
        methods: {
            ...mapActions([
                'createSuccessNotification',
                'resetSelectedItems',
                'resetResendSMS'
            ]),
            onSubmit() {
                if (!this.isLoading) {
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            this.isLoading = true;
                            this.form.entityIds = this.selected;
                            if (!this.pagesWithPrimaryOrSecondaryParentOption.includes(this.$route.path)) {
                                if (this.entitySelected.includes("secondary")) {
                                    this.form.secondaryEntityIds = this.selected;
                                }
                                if (!this.entitySelected.includes("primary")) {
                                    this.form.entityIds = [];
                                } 
                            }
                            const body = JSON.stringify(this.form);
                            this.useService(body)
                                .then(() => {
                                    this.$emit('submit');
                                    this.resetSelectedItems();
                                    this.createSuccessNotification('SMS was successfully sent');
                                })
                                .finally(() => this.isLoading = false);
                        }
                    });
                }
            },
            // the methods will be overwritten from inherited component
            useService() {},
        },
        beforeMount() {
            if(this.resendSMS && this.$route.path === "/settings/sms_history") {
                this.form = {
                    message: this.resendSMS.message,
                    id: this.resendSMS.id,
                    schoolId: this.schoolId,
                }
            }
        },
        beforeDestroy() {
            if(this.resendSMS) {
                this.resetResendSMS();
            }
        },
    }
</script>
<style scoped>
    textarea {
        height: 210px;
        white-space: normal;
    }

    .custom-control-label {
        padding-top: 2px !important;
    }

    .checkbox {
        margin-bottom: 15px;
        font-family: Asap;
        font-size: 16px;
        color: #888b94;
    }
    .checkbox__input {
        display: flex;
        flex-direction: column;
    }
    .checkbox-item__container {
        display: flex;
        align-items: center;
    }

    .checkbox__input label {
        margin-left: 26px;
    }

    .checkbox__select-label {
        margin-bottom: 15px;
    }

    input[type=checkbox] {
        position: relative;
	    cursor: pointer;
        border: none !important;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 24px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    input[type=checkbox]:before {
        content: "";
        display: block;
        position: absolute;
        width: 18px;
        height: 18px;
        top: 0;
        left: 0;
        border: 2px solid #e9edf0;
    }
    input[type=checkbox]:before:hover {
        background-color: #f7f8f9 !important;
    }
    
    input[type=checkbox]:checked:before {
        content: "";
        display: block;
        position: absolute;
        width: 18px;
        height: 18px;
        top: 0;
        left: 0;
        background-color: #64c8ff !important;
        border: 2px solid #64c8ff;
    }
    
    input[type=checkbox]:checked:after {
        content: "";
        display: block;
        width: 8px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        position: absolute;
        top: 1px;
        left: 5px;
    }

    .message-note {
        color: #888b94;
        margin-top: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/SendSMSModal.vue